import axios from "axios";
import {
  GET_TABLE_OR_LIST_DETAILS,
  GET_TABLE_OR_LIST,
  POST_TABLE_OR_LIST,
  PUT_STATUS_TABLE_OR_LIST,
} from "..";

/**
 * reportDownloadSent list
 * @param {parameters} paramObj
 * @returns
 */

export const getTableOrListing = (paramObj) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${GET_TABLE_OR_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramObj,
  });
};

/**
 * create reportDownloadSent
 * @param {body} body
 * @returns
 */
export const postTableOrListing = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}${POST_TABLE_OR_LIST}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

/**
 * update tableoRListing
 * @param {body} body
 * @returns
 */
export const putUpdateTableOrListing = (newData) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${POST_TABLE_OR_LIST}`,
    newData,
    {
      headers: { Authorization: jwt_token },
      params: { tableOrListingId: newData.id },
    }
  );
};

/**
 * delete reportDownloadSent
 * @param {id} tableOrListingId
 * @returns
 */
export const deleteTableOrListing = (tableOrListingId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.delete(`${process.env.REACT_APP_API_URL}${POST_TABLE_OR_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { tableOrListingId: tableOrListingId },
  });
};

/**
 * get reportDownloadSent details
 * @param {id} tableOrListingId
 * @returns
 */
export const getTableOrListingDetails = (tableOrListingId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(
    `${process.env.REACT_APP_API_URL}${GET_TABLE_OR_LIST_DETAILS}`,
    {
      headers: { Authorization: jwt_token },
      params: { tableOrListingId: tableOrListingId },
    }
  );
};

/**
 * enable-disable
 * @param {body} body
 * @returns
 */
export const updateStatus = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${PUT_STATUS_TABLE_OR_LIST}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};
